// Icon mappings for JSON config
export const ICON_MAP = {
  ICON_INFORMATION: 'Info',
  ICON_REPORT: 'FileText',
  ICON_HELP: 'HelpCircle',
  ICON_SETTINGS: 'Settings',
  ICON_CHART: 'BarChart',
  ICON_TRENDING: 'TrendingUp',
  ICON_PIE: 'PieChart',
  ICON_SPREADSHEET: 'Grid',
  ICON_HOME: 'Home',
  ICON_USER: 'User',
  ICON_BELL: 'Bell',
  ICON_CALENDAR: 'Calendar',
  ICON_STAR: 'Star',
  ICON_SHIELD: 'Shield',
  ICON_GLOBE: 'Globe',
  ICON_DOWNLOAD: 'Download',
}

// Color mappings for JSON config
export const COLOR_MAP = {
  red: '#dc3545',
  orange: '#fd7e14',
  green: '#198754',
  blue: '#0d6efd',
  purple: '#6f42c1',
  indigo: '#6610f2',
  pink: '#d63384',
  teal: '#20c997',
  yellow: '#ffc107',
}

// Grid column mappings
export const GRID_COL_MAP = {
  1: { xs: 12 },
  2: { xs: 12, md: 6 },
  3: { xs: 12, md: 6, lg: 4 },
  4: { xs: 12, md: 6, lg: 3 },
}

export const GRID_COL_HALF_MAP = {
  1: { xs: 12 },
  2: { xs: 12, md: 6 },
  3: { xs: 12, md: 6, lg: 4, halfLg: 6 },
  4: { xs: 12, md: 6, lg: 6, halfLg: 6 },
}

// Predefined templates in JSON format
export const JSON_TEMPLATES = {
  homeweavers: {
    template: 'HOMEWEAVERS',
    settings: {
      grid: 4,
    },
    categories: [
      {
        title: 'Keuangan',
        widgets: [
          { type: 'CARD_UANG_BELANJA' },
          { type: 'CARD_UANG_USAHA' },
          { type: 'CARD_TALANGIN' },
        ]
      },
      {
        title: 'Aktivitas Utama',
        widgets: [
          { type: 'TRANSAKSI_AKTIF', fullWidth: true },
          { type: 'PENGADUAN' },
          { type: 'ABSENSI' },
          { type: 'EVENT' },
          { type: 'CASHFLOW', fullWidth: true },
        ]
      },
      {
        title: 'Menu Pintasan',
        widgets: [
          {
            type: 'GENERIC_LINK',
            params: {
              title: 'Bantuan',
              description: 'Pusat bantuan dan panduan lengkap',
              icon: 'ICON_INFORMATION',
              color: 'orange',
            },
          },
          {
            type: 'GENERIC_LINK',
            params: {
              title: 'Laporan',
              description: 'Dashboard laporan lengkap dan analisis data',
              icon: 'ICON_REPORT',
              color: 'purple',
              url: 'http://business.pasarmikro.id/app/reports',
            },
          },
          {
            type: 'GENERIC_LINK',
            params: {
              title: 'Statistik',
              description: 'Statistik dan metrik kinerja',
              icon: 'ICON_CHART',
              color: 'purple',
              url: 'http://business.pasarmikro.id/app/reports/statistics',
            },
          },
          {
            type: 'GENERIC_LINK',
            params: {
              title: 'Trending',
              description: 'Analisis tren dan perkembangan',
              icon: 'ICON_TRENDING',
              color: 'purple',
              url: 'http://business.pasarmikro.id/app/reports/trending',
            },
          },
          {
            type: 'GENERIC_LINK',
            params: {
              title: 'Grafik',
              description: 'Visualisasi data dalam grafik',
              icon: 'ICON_PIE',
              color: 'purple',
              url: 'http://business.pasarmikro.id/app/reports/charts',
            },
          },
          {
            type: 'GENERIC_LINK',
            params: {
              title: 'Pengaturan',
              description: 'Konfigurasi dan pengaturan sistem',
              icon: 'ICON_SETTINGS',
              color: 'pink',
              url: 'http://business.pasarmikro.id/app/settings',
            },
          },
        ]
      }
    ],
  },
}

// Function to get templates with localStorage support
export const getTemplates = () => {
  // Check if localStorage is available (client-side only)
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return JSON_TEMPLATES
  }

  // Check if there's a custom configuration in localStorage
  const customConfig = localStorage.getItem('templateConfig')

  if (customConfig) {
    try {
      const parsedConfig = JSON.parse(customConfig)
      return {
        ...JSON_TEMPLATES,
        ...parsedConfig,
      }
    } catch (error) {
      console.error('Error parsing custom config:', error)
      return JSON_TEMPLATES
    }
  }

  return JSON_TEMPLATES
}

// Function to reset configuration
export const resetConfiguration = () => {
  if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
    localStorage.removeItem('templateConfig')
    window.location.reload()
  }
}
